import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Glyphicon, Button, OverlayTrigger, Tooltip } from '@bingads-webui-react/primitive';
import { withLayoutContext } from '@bingads-webui-react/app-layout-container';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import {
  withAccountsSiteMap,
  siteMapPropType,
  ScopeV2,
} from '@bingads-webui-react/with-site-map';

import { getBackToCampaignItemStyles } from './back-to-campaign-item-styles';

const BackToAccountItem = ({
  siteMap, classes, i18n, activity, scope,
}) => {
  const selectedParent = _.findWhere(siteMap, { selected: true });
  if (selectedParent || scope.values.aid) {
    return null;
  }
  return (
    <div className={classNames(classes.BackToAccountItemContainer, 'back-to-campaign-button-container')}>
      <OverlayTrigger
        key="back-button-tooltip"
        placement="right"
        delayShow={300}
        overlay={
          <Tooltip id="tooltip-right">
            {i18n.getString(_TL_('Back to Accounts'))}
          </Tooltip>
          }
      >
        <Button
          className={classNames(classes.backToCampaignButton, 'back-to-campaign-button')}
          onClick={() => {
            activity.signal('Back to account button clicked');
            const pathname = '/campaign/vnext/accounts';
            const search = `?${scope.stringify(ScopeV2.trimToScope(ScopeV2.Account, scope.values))}`;
            scope.history.push({
              pathname,
              search,
            });
          }}
          btnStyle="command"
          aria-label={i18n.getString(_TL_('Back to Accounts'))}
        >
          <Glyphicon
            id="button-icon"
            className={classes.buttonIcon}
            glyph="ba-Back"
          />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

BackToAccountItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getBackToCampaignItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  siteMap: siteMapPropType.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  activity: PropTypes.shape({
    signal: PropTypes.func,
  }),
};

BackToAccountItem.defaultProps = {
  activity: {
    signal: _.noop,
  },
};

export default
withScope((withAccountsSiteMap(withLayoutContext(withActivityContext(withDefaultStyles(
  BackToAccountItem,
  getBackToCampaignItemStyles
))))));
